define('OutSystems/ClientRuntime/modules/Database/DBDataType',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DBDataType;
    (function (DBDataType) {
        DBDataType[DBDataType["TEXT"] = 0] = "TEXT";
        DBDataType[DBDataType["BINARY_DATA"] = 1] = "BINARY_DATA";
        DBDataType[DBDataType["BOOLEAN"] = 2] = "BOOLEAN";
        DBDataType[DBDataType["INTEGER"] = 3] = "INTEGER";
        DBDataType[DBDataType["LONGINTEGER"] = 4] = "LONGINTEGER";
        DBDataType[DBDataType["DECIMAL"] = 5] = "DECIMAL";
        DBDataType[DBDataType["DATE_TIME"] = 6] = "DATE_TIME";
        DBDataType[DBDataType["DATE"] = 7] = "DATE";
        DBDataType[DBDataType["TIME"] = 8] = "TIME";
        DBDataType[DBDataType["UNKNOWN"] = 9] = "UNKNOWN";
    })(DBDataType || (DBDataType = {}));
    exports.default = DBDataType;
});
//# sourceMappingURL=DBDataType.js.map;
